<template>
  <div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Relatórios</h5>
                <hr>
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-12">                      
                        <Dropdown v-model="linkRelatirio" :options="relatorios" optionLabel="nome" optionValue="link" @hide="carregarPagina"
                            :filter="true" placeholder="Selecione um relatório"/>
                        <hr>
                    </div>				             
                </div> 
                <router-view></router-view>
			</div>
		</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            paginaAtual: '',
            linkRelatirio: '',
            relatorios: [],
        }
    },
    methods: {
        ...mapGetters('sessao', ['getPermissoes']),
        carregarPagina() {                
            if(this.paginaAtual != this.linkRelatirio) {
                this.paginaAtual = this.linkRelatirio;
                this.$router.push(this.linkRelatirio);
            }
        },
        carregarRelatorios() {
            let permissoes = this.getPermissoes();
            let definidos = [];
            definidos.push({nome:'Clientes', link:'/relatorios/clientes', permissao:99999});
            definidos.forEach(relatorio => {     
                if(permissoes.includes(relatorio.permissao)) {
                    this.relatorios.push(relatorio);
                }     
            });
        }
    },
    mounted() {
        this.carregarRelatorios();
    }
}
</script>

<style>
    
</style>